import PermissionByModuleAndRole from "./PermissionByModuleAndRole";

export default PermissionByModuleAndRole;
